import React, { FC, useCallback, useState } from "react";

import { OnboardingAside, OnboardingContent, PrimaryAlternateControl, URLInput, validateURL } from "@xapp/components";

export interface WebsiteStepProps {
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;
    /**
     * Optional aside content
     */
    aside?: React.ReactNode;
    /**
     * Optional website initial value
     */
    website?: string;
    /**
     * User has selected a website
     */
    onWebsite(website: string): void;
}

export const WebsiteStep: FC<WebsiteStepProps> = (props) => {
    const { aside, onWebsite } = props;
    const [website, setWebsite] = useState<string>(props.website || "");
    const [valid, setValid] = useState<boolean>(validateURL(props.website).valid);

    const handleWebsiteChange = useCallback((value: string, valid: boolean) => {
        setWebsite(value);
        setValid(valid);
    }, []);

    const disableContinue = !website || !valid;

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}
            <OnboardingContent>
                <h3>Enter your Website</h3>
                <URLInput placeholder="https://" value={website} onChange={handleWebsiteChange} variation="outlined" />
                <PrimaryAlternateControl
                    labels={{ primary: "Train my Agent", alternate: "Train without Website" }}
                    disabled={{ primary: disableContinue }}
                    onPrimary={onWebsite.bind(null, website)}
                    onAlternate={() => {}}
                />
            </OnboardingContent>
        </>
    );
};
